import request from '../request'
import store from '../../store'

// 仪表盘-各区域年度补贴机具数量统计 (顶部6项数据)
export function getStatistic(params) {
  return request.get("../largescreen/govsubsidy/statistic", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 机具补贴情况
export function getMachinerySubsidyList(params) {
  return request.get("../largescreen/govsubsidy/statistic/mcc", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 补贴数量前五名机具
export function getMachinerySubsidyRank(params) {
  return request.get("../largescreen/govsubsidy/top/mcc", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 历年补贴资金规模
export function getSubsidyByYear(params) {
  return request.get("../largescreen/govsubsidy/getSubsidyByYear", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 资金使用量前五名机具
export function getSubsidyTop(params) {
  return request.get("../largescreen/govsubsidy/top/subsidy", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 年度各月数据同比
export function getLastYearRatio(params) {
  return request.get("../largescreen/govsubsidy/getLastYearRatio", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 年度各月数据环比
export function getLastMonthRatio(params) {
  return request.get("../largescreen/govsubsidy/getLastMonthRatio", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 年度各月资金使用兑付情况
export function getSubsidyUseByYear(params) {
  return request.get("../largescreen/govsubsidy/getSubsidyUseByYear", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 各区域使用率兑付率
export function getAreaUsed(params) {
  return request.get("../largescreen/govsubsidy/getAreaUsed", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 各区域补贴情况
export function getAreaMachineInfo(params) {
  return request.get("../largescreen/govsubsidy/getAreaMachineInfo", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 区域点位维护-根据父级ID查询下级区域列表
export function getAreaLonAndLat(parentId) {
  return request.get("../system/area/maintain/getAreaListByParentId/" + parentId).then((res) => {
    let points = res;
    for(let i = 0; i < points.length;i++) {
      // 把经纬度不存在、不符合标准的去掉
      if(!points[i] || !points[i].latitude || !points[i].longitude || !points[i].lat || !points[i].lon || (points[i].longitude <= -180 && points[i].longitude >= 180) || (points[i].latitude <= -90 && points[i].latitude >= 90)
        || (points[i].lon <= -180 && points[i].lon >= 180) || (points[i].lat <= -90 && points[i].lat >= 90)
      ) {
        points.splice(i, 1);
        if(i > 0) {
          i--;
        }else {
          i = 0;
        }
      }
    }
    return points;
  });
}

// 政务获取最后一次跟新时间 
// type 值
// BF 报废补贴
// BT 购置补贴
// JL 农机监理
// JD 农机鉴定
export function getLastUpdateTime(type) {
  return request.get("../yunxing/governmentDataSync/getLastSyncTime/" + type).then((res) => res);
}
